import { useEffect, useState } from 'react';

const breakpoints = {
  xs: 480,
  sm: 640,
  md: 760,
  lg: 960,
  xl: 1280,
  '2xl': 1536,
};

/**
 * Returns true if the screen width is at least (`min`) or at most (`max`) the
 * breakpoint: a named one, or a width in pixels.
 */
export const useMediaQuery = (
  query: KeyOf<typeof breakpoints> | number,
  behavior: 'min' | 'max' = 'min',
  initialValue: boolean = false,
) => {
  const [result, setResult] = useState(initialValue);
  const width = typeof query === 'number' ? query : breakpoints[query];
  useEffect(() => {
    const evaluateWindowSize = () => {
      setResult(
        behavior === 'min'
          ? window.innerWidth >= width
          : window.innerWidth <= width,
      );
    };
    addEventListener('resize', evaluateWindowSize);
    evaluateWindowSize();
    return () => removeEventListener('resize', evaluateWindowSize);
  }, [behavior, width]);
  return result;
};
